import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectTemplatesTenantAdditionalLanguages } from '../store/templatesSlice';
import { buildLanguageOptions, tenantHasLanguageChoice } from '../lib/languageHelpers';

// The tenant's languages in display order: English first, then whatever else it enabled.
export function useTenantLanguages() {
  const additionalLanguages = useSelector(selectTemplatesTenantAdditionalLanguages);

  return useMemo(
    () => ({
      languages: buildLanguageOptions({ additionalLanguages }).map((option) => option.value),
      hasMultipleLanguages: tenantHasLanguageChoice(additionalLanguages),
    }),
    [additionalLanguages],
  );
}
